var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 53,
    viewBox: "0 0 35 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3203 4C11.5872 4 7.73633 7.85084 7.73633 12.584V29.4546C7.73633 34.1871 11.5872 38.038 16.3203 38.038C21.0534 38.038 24.9043 34.2139 24.9043 29.5135V12.584C24.9043 7.85084 21.0534 4 16.3203 4ZM21.3271 29.513C21.3271 32.2409 19.0809 34.4607 16.3203 34.4607C13.5597 34.4607 11.313 32.2152 11.313 29.454V12.584C11.313 9.82282 13.5591 7.57665 16.3203 7.57665C19.0815 7.57665 21.3276 9.82282 21.3271 12.584V29.513Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1089 43.165H14.5322V51.2126H18.1089V43.165Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0292 49.4229H11.6106C10.6228 49.4229 9.82227 50.2234 9.82227 51.2112C9.82227 52.1989 10.6228 52.9995 11.6106 52.9995H21.0292C22.017 52.9995 22.8175 52.1989 22.8175 51.2112C22.8175 50.2234 22.017 49.4229 21.0292 49.4229Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8519 26.4736C28.8641 26.4736 28.0635 27.2742 28.0635 28.262V29.6926C28.0635 36.1676 22.7951 41.4361 16.3201 41.4361C9.84458 41.4361 4.57665 36.1677 4.57665 29.6926V28.262C4.57665 27.2742 3.77608 26.4736 2.78832 26.4736C1.80056 26.4736 1 27.2742 1 28.262V29.6926C1 38.1401 7.8726 45.0127 16.3201 45.0127C24.7676 45.0127 31.6402 38.1401 31.6402 29.6926V28.262C31.6402 27.2743 30.8396 26.4736 29.8519 26.4736Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L33 50.5",
    stroke: "black",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteDarkIcon);
export default __webpack_public_path__ + "static/media/muteDarkIcon.d5e11057abd7977c37d200e7e2edc5c5.svg";
export { ForwardRef as ReactComponent };